/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Content from './Content/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentLeftClick from 'DesignSystem/Popover/PopoverContentLeftClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2ChevronDown from 'DesignSystem/Svgs/Tysiav2ChevronDown/index'
import Tysiav2CrossLocation from 'DesignSystem/Svgs/Tysiav2CrossLocation/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/Existing/Content/LocationSelect/Content/Content"
  
}) {
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let tabSelectedLocationNameValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.location_name',
})
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 placement="bottom-end"
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2CrossLocation
  viewPath={`${viewPath}/Tysiav2CrossLocation`}
 width={12}
 height={12}
 fill2={dtColorsNeutral400}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="tab.selected.location_name"
 text={tabSelectedLocationNameValueData}
 size="small"
 weight="medium"
 width={88}
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 overflowX="hidden"
 display="inline-block"
/>
<Tysiav2ChevronDown
  viewPath={`${viewPath}/Tysiav2ChevronDown`}
 width={12}
 height={12}
 fill2={dtColorsNeutral400}
/>
</div>
)}
</PopoverTrigger>
<PopoverContentLeftClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentLeftClick`}
 width={240}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PopoverContentLeftClick>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}